import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export const LayoutCardContainer = ({ children, scrollRef }: ContainerProps) => {
  return (
    <div ref={scrollRef} className="flex h-full flex-col gap-[8px] overflow-y-auto   bg-white ">
      {children}
    </div>
  );
};
